export default __webpack_public_path__ + "static/media/logo-linkedin.9ab1461c.svg";